/**
 * Check if a DOM element is visible
 * @param el - element to check
 * @param root - root node
 * @returns {Boolean} - true if fisible
 */
export default function isElementVisible(el, root = document) {
    if (el === root) {
        return true;
    }

    if (!el || !el.parentNode) {
        return false;
    }

    const style = window.getComputedStyle(el);

    if (!style || style.display === 'none' || style.visibility === 'hidden') {
        return false;
    }

    return isElementVisible(el.parentNode, root);
}



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/util/dom/is-element-visible.js